module.exports = __webpack_public_path__ + "7b3bdc45b36e5cb66db4591d28c95f2b.svg";